import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { FormBuilder, ReactiveFormsModule, Validators } from "@angular/forms";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { TranslateModule } from "@ngx-translate/core"; // Import thêm module này
import { ContactLeadRequest } from "src/app/shared/models/contact-request.interface";
import { ContactService } from "src/app/shared/services/contact.service";

@Component({
  selector: "app-contact-page",
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule], // Đã thêm TranslateModule
  templateUrl: "./contact-page.component.html",
  styleUrl: "./contact-page.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactPageComponent implements OnInit {
  contactForm = this.fb.nonNullable.group({
    firstName: ["", Validators.required],
    lastName: ["", Validators.required],
    email: ["", [Validators.required, Validators.email]],
    phone: [
      "",
      [
        Validators.required,
        Validators.pattern(/^[0-9]{10}$/),
        Validators.maxLength(10),
      ],
    ],
    message: ["", Validators.required],
  });
  mapUrl!: SafeResourceUrl;
  private address =
    "Tòa nhà Đại Phát, 185B Hà Huy Giáp, Phường Thạnh Lộc, Quận 12, Thành phố Hồ Chí Minh";

  constructor(
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private contactService: ContactService
  ) { }

  ngOnInit(): void {
    const encodedAddress = encodeURIComponent(this.address);
    // Lưu ý: Sửa lại template string cho url để tránh lỗi hiển thị map
    const url = `https://www.google.com/maps?q=${encodedAddress}&output=embed`;
    this.mapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  submit(): void {
    if (this.contactForm.invalid) return;

    const formValue = this.contactForm.getRawValue();
    const payload: ContactLeadRequest = {
      fullName: `${formValue.firstName} ${formValue.lastName}`.trim(),
      emailContact: formValue.email,
      phoneNumber: formValue.phone || null,
      quantity: 1,
      note: formValue.message,
    };

    this.contactService.submitContact(payload).subscribe({
      next: () => {
        // Bạn có thể dùng TranslateService.get() nếu muốn dịch cả thông báo alert
        alert("Gửi liên hệ thành công! Chúng tôi sẽ phản hồi sớm nhất");
        this.contactForm.reset();
      },
      error: (err) => {
        console.error("Submit fail", err);
      }
    });
  }
}